import React from 'react';

import * as T from '../../components/Typography';
import { Row, Col } from '../../components/Grid';
import { SectionLayout } from '../../components/Layouts';

import GraphicBurst from '../../components/GraphicBurst';

import data from './data';

const ValuesSection = () => {
  return (
    <SectionLayout id="our-values">
      <T.H4Bold color="midnight" caps>
        OUR VALUES
      </T.H4Bold>
      <Row mt={2} mtT={0} jcT="center">
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[0].image}
            leftAligned={data[0].leftAligned}
            title={data[0].title}
            location={data[0].location}
            description={data[0].description}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[1].image}
            leftAligned={data[1].leftAligned}
            title={data[1].title}
            location={data[1].location}
            description={data[1].description}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[2].image}
            leftAligned={data[2].leftAligned}
            title={data[2].title}
            location={data[2].location}
            description={data[2].description}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[3].image}
            leftAligned={data[3].leftAligned}
            title={data[3].title}
            location={data[3].location}
            description={data[3].description}
          />
        </Col>
        <Col w={[4, 3, 4]} mt={4} mtT={5}>
          <GraphicBurst
            image={data[4].image}
            leftAligned={data[4].leftAligned}
            title={data[4].title}
            location={data[4].location}
            description={data[4].description}
          />
        </Col>
      </Row>
    </SectionLayout>
  );
};

export default ValuesSection;
